import { Box, Divider, Flex, Text } from "@chakra-ui/react";
import FlagIcon from "../../../assets/icons/milestone-flag.svg";
import { renderToHTML } from "common";
import { MilestoneUpdate } from "./MilestoneUpdate";
import { MilestoneBadge } from "./MilestoneBadge";
import { dateFromMs } from "../../api/utils";
import { useMemo } from "react";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const MilestoneItem = _ref => {
  var _milestone$completed;
  let {
    milestone,
    badgeTitle
  } = _ref;
  const deadlineText = milestone.completed ? `${milestone.isGrantUpdate ? "Posted" : "Completed"} on ${dateFromMs(milestone.completed.createdAtMs)}` : `Due on ${dateFromMs(milestone.endsAtMs)}`;
  const statusBadgeProps = useMemo(() => {
    if (milestone.endsAtMs < Date.now() / 1000) {
      return {
        title: "Past due",
        classNames: "bg-red-500 text-white"
      };
    }
    return milestone.completed ? {
      title: "Completed",
      classNames: "bg-gray-100"
    } : {
      title: "Pending",
      classNames: "bg-gray-500 text-white"
    };
  }, [milestone]);
  return /*#__PURE__*/_jsxs(Box, {
    borderWidth: 1,
    borderColor: "gray.200",
    borderRadius: "md",
    py: 4,
    px: 2,
    children: [/*#__PURE__*/_jsxs(Flex, {
      justifyContent: "space-between",
      mb: 5,
      flexWrap: "wrap",
      children: [/*#__PURE__*/_jsxs(Flex, {
        justifyContent: "space-between",
        w: ["full", "full", "full", "fit-content"],
        children: [/*#__PURE__*/_jsx(MilestoneBadge, {
          icon: FlagIcon,
          title: badgeTitle
        }), /*#__PURE__*/_jsx(Box, {
          className: "initial lg:hidden",
          children: !milestone.isGrantUpdate && /*#__PURE__*/_jsx(MilestoneBadge, {
            ...statusBadgeProps
          })
        })]
      }), /*#__PURE__*/_jsxs(Flex, {
        gap: 5,
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(Text, {
          mt: "-2px",
          children: /*#__PURE__*/_jsx("small", {
            children: deadlineText
          })
        }), /*#__PURE__*/_jsx(Box, {
          className: "hidden lg:flex",
          children: !milestone.isGrantUpdate && /*#__PURE__*/_jsx(MilestoneBadge, {
            ...statusBadgeProps
          })
        })]
      })]
    }), /*#__PURE__*/_jsx(Flex, {
      mb: 3,
      children: /*#__PURE__*/_jsx(Text, {
        fontWeight: "bold",
        children: milestone.title
      })
    }), /*#__PURE__*/_jsx(Flex, {
      children: /*#__PURE__*/_jsx(Box, {
        dangerouslySetInnerHTML: {
          __html: renderToHTML(milestone.description)
        }
      })
    }), !!((_milestone$completed = milestone.completed) !== null && _milestone$completed !== void 0 && _milestone$completed.text) && !milestone.isGrantUpdate && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Divider, {
        my: 3
      }), /*#__PURE__*/_jsx(MilestoneUpdate, {
        ...milestone.completed
      })]
    })]
  });
};